export const DAY_NAMES = ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'];
export const STATUS = {pending:'Pendiente',confirmed:'Confirmada',completed:'Completada',cancelled:'Cancelada',no_show:'No asistió'};
export function parts(value, zone='America/Mexico_City') {
  const date=new Date(value);
  if(Number.isNaN(date.valueOf())) return null;
  const p=Object.fromEntries(new Intl.DateTimeFormat('en-CA',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(date).map(x=>[x.type,x.value]));
  return {day:`${p.year}-${p.month}-${p.day}`,minute:Number(p.hour)*60+Number(p.minute)};
}
export const addDays=(key,n)=>new Date(Date.parse(key+'T12:00:00Z')+n*86400000).toISOString().slice(0,10);
export const weekStart=key=>addDays(key,-((new Date(key+'T12:00:00Z').getUTCDay()+6)%7));
export const monthDays=key=>Array.from({length:42},(_,i)=>addDays(weekStart(key.slice(0,7)+'-01'),i));
export const clock=n=>`${String(Math.floor(n/60)).padStart(2,'0')}:${String(n%60).padStart(2,'0')}`;
export const label=(key,options)=>new Intl.DateTimeFormat('es-MX',{...options,timeZone:'UTC'}).format(new Date(key+'T12:00:00Z'));
export const normalize=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
export function segment(apt, day, zone) {
  const start=parts(apt.appointment_date,zone);
  if(!start)return null;
  const end=parts(new Date(new Date(apt.appointment_date).valueOf()+Math.max(1,Number(apt.duration_minutes)||30)*60000),zone);
  if(day<start.day||day>end.day||(day===end.day&&end.minute===0))return null;
  return {apt,start:day===start.day?start.minute:0,end:day===end.day?end.minute:1440};
}
export function layoutDay(appointments,day,zone) {
 const events=appointments.map(a=>segment(a,day,zone)).filter(Boolean).sort((a,b)=>a.start-b.start||b.end-a.end);
 let group=[],end=-1;
 const flush=()=>{const lanes=[];for(const e of group){let lane=lanes.findIndex(stop=>stop<=e.start);if(lane<0)lane=lanes.length;lanes[lane]=e.end;e.lane=lane;}for(const e of group)e.columns=lanes.length;group=[];};
 for(const e of events){if(e.start>=end){flush();end=-1;}group.push(e);end=Math.max(end,e.end);}flush();return events;
}
